import React from 'react';
import Customer from '../../../assets/Customer.svg';
import './NewCustomerNote.scss';
import { useTranslation } from 'react-i18next';
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";

const NewCustomerNote: React.FC<any> = ({ rtl }) => {
    const { t } = useTranslation();
    return (
        <div className='note-container'>
            <div className='note-header-container'>
                <img className={`customer-icon`} src={Customer} alt="customer" />
                <Typography className='note-header' rtl={rtl}>{t("New_Customer")}</Typography>
            </div>
            <div>
                <Typography className='note-data fw-600' rtl={rtl}>{t("New_Customer_Note1")}</Typography>
                <div className='bullet-points'>
                    <Typography className='note-data' rtl={rtl}>{t("New_Customer_Bullet1")}</Typography>
                    <Typography className='note-data' rtl={rtl}>{t("New_Customer_Bullet2")}</Typography>
                    <Typography className='note-data' rtl={rtl}>{t("New_Customer_Bullet3")}</Typography>
                </div>
                <Typography className='note-data fw-400' rtl={rtl}>{t("New_Customer_Note2")}</Typography>
                <Typography className='note-data' rtl={rtl}>
                    <span className='note-data-imp'>{t("Existing_Customer_Note4_1")}</span>{" "}
                    <span className='font-weight-bold'>{t("Existing_Customer_Note4_2")}</span>
                </Typography>
                <Typography className='note-data' rtl={rtl}>{t("Existing_Customer_Note5_1")}{" "}
                     <span className='note-data-stamp'>{t("Existing_Customer_Note5_2")
                    }</span> {t("Existing_Customer_Note5_3")} <span className='mobily-blue' dir='ltr'>901@mobily.com.sa</span> {t("Existing_Customer_Note5_4")}</Typography>
            </div>
        </div>
    )
}

export default NewCustomerNote;